<script>
  import router from '../lib/router';
  import { onMount, tick } from 'svelte';
  import { MDCSwitch } from '@material/switch';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session';
  import APIClient from '../state-charts/api-client';
  import AuthenticatedLayout from '../app-shell/authorized-app/Layout.svelte';

  // component options  ------------------------------------------------------ //

  export let route_name;

  // translated strings ------------------------------------------------------ //

  let title = t9n(TS.WORKER_TEAMS_TITLE);
  let explanation = t9n(TS.WORKER_TEAMS_EXPLANATION);
  let exp_no_teams = t9n(TS.WORKER_TEAMS_USER_WITHOUT_TEAMS);
  let change_text = t9n(TS.WORKER_TEAMS_CHANGE_TEXT);
  let private_teams_title = t9n(TS.WORKER_TEAMS_PRIVATE_TEAMS_TITLE);

  // internal variables ------------------------------------------------------ //

  let teams = [];

  // utility functions -------------------------------------------------------- //

  const get_teams = () => {
    teams = $session.user.teams;
  };

  const update_team = async e => {
    const team_id = e.target.dataset.team_id;
    const active = e.target.checked;
    const team = teams.find(t => t.team.team_id.toString() === team_id);

    team.activated = active;

    const data = {
      teams: teams.map(t => ({
        activated: t.activated,
        team_id: t.team.team_id,
      })),
    };
    await APIClient.update_profile(data);
    get_teams();
  };

  const init = async () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})
   // if ($session.role !== 'worker') router.navigate('/home');
    get_teams();

    await tick();

    let switches = Array.from(document.querySelectorAll('.mdc-switch'));
    switches.map(s => new MDCSwitch(s));
  };

  onMount(async () => {
    await init();
  });

  // reactive functions ------------------------------------------------------- //
</script>

  <main class="main--global wrapper fade-in">
    <!-- Header -->
    <div style="text-align: center;">
      <h1 style="margin-bottom: 25px" class="mdc-typography--headline5">
        {title}
      </h1>
    </div>

    <!-- Help line -->
    <div id="help-liner" class="fade-in-long" style="margin-top: -20px">
      <div class="tooltip-default ">
        <span id="tooltip_def" class="tooltip-text tooltip-top">
          {explanation}
        </span>
      </div>
    </div>

    <!-- Team blocks -->
    <div id="worker_teams" class="row">
      <div id="my_teams_wrap" class="column">
        <h4 class="mdc-typography--headline7" style="margin-top: 20px">
          {change_text}
        </h4>

        <!-- My team switch loop -->
        <div id="my_team_switch-wrap" style="margin-top: 20px;">
          {#each teams as t}
            {#if !t.team.is_private}
              <div style="margin-bottom: 1em">
                <div class="mdc-switch">
                  <div class="mdc-switch__track" />
                  <div
                    class="mdc-switch__thumb-underlay mdc-ripple-upgraded
                    mdc-ripple-upgraded--unbounded"
                    style="--mdc-ripple-fg-size:28px;
                    --mdc-ripple-fg-scale:1.7142857142857142;
                    --mdc-ripple-left:10px; --mdc-ripple-top:10px;">
                    <div class="mdc-switch__thumb">
                      <input
                        type="checkbox"
                        id="public-task-switch-{t.team.team_id}"
                        data-team_id={t.team.team_id}
                        class="mdc-switch__native-control"
                        role="switch"
                        aria-checked="true"
                        on:change|stopPropagation={update_team}
                        checked={t.activated} />
                    </div>
                  </div>
                </div>
                <label
                  style="margin-left: 10px"
                  for="task-switch-{t.team.team_id}">
                  {t.team.name}
                </label>
              </div>
            {/if}
          {/each}
        </div>
      </div>

      <div id="my_private_teams_wrap" class="column">
        <h4 class="mdc-typography--headline7" style="margin-top: 15px">
          {private_teams_title}
        </h4>

        <!-- My private team switch loop -->
        <div id="private_team_switch-wrap" style="margin-top: 20px">
          {#each teams as t}
            {#if t.team.is_private}
              <div style="margin-bottom: 1em">
                <div class="mdc-switch mdc-switch">
                  <div class="mdc-switch__track" />
                  <div
                    class="mdc-switch__thumb-underlay mdc-ripple-upgraded
                    mdc-ripple-upgraded--unbounded"
                    style="--mdc-ripple-fg-size:28px;
                    --mdc-ripple-fg-scale:1.7142857142857142;
                    --mdc-ripple-left:10px; --mdc-ripple-top:10px;">
                    <div class="mdc-switch__thumb">
                      <input
                        type="checkbox"
                        id="private-task-switch-{t.team.team_id}"
                        data-team_id={t.team.team_id}
                        class="mdc-switch__native-control"
                        role="switch"
                        aria-checked="true"
                        on:change={update_team}
                        bind:checked={t.activated} />
                    </div>
                  </div>
                </div>
                <label
                  style="margin-left: 10px"
                  for="task-switch-{t.team.team_id}">
                  {t.team.name}
                </label>
              </div>
            {/if}
          {/each}
        </div>
      </div>
    </div>

    {#if teams.length <= 0}
      <div>{exp_no_teams}</div>
    {/if}

  </main>

<style type="text/scss">
  /* Reset Styles
    *******************************************************/
  * {
    box-sizing: border-box;
    margin: 0;
    text-decoration: none;
  }

  html,
  body,
  main {
    display: flex;
    flex-direction: column;
  }

  /* Actual page
    *******************************************************/
  .row {
    display: flex;
  }

  .column {
    flex: 50%;
  }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::before {
    content: ' ';
    position: relative;
    top: -30px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #018786 transparent;
    left: 69px;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 900px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
      padding: 30px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    .row {
      display: block;
    }
  }
</style>
